var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.sparkline)?_c('SparklineChart',{attrs:{"name":_vm.monitor.column,"unit":_vm.monitor.columnUnit,"line":_vm.sparkline.value,"time":_vm.timeseries.time}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }